import React, { useEffect, useState } from "react";
import PdfViewer from "../components/PdfViewer";
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";

//RepPA
const AyudaAdmin = () =>{
    const navigate = useNavigate();

    const [admin, setAdmin] = useState(false);
        const validarSesion = () =>{
        if(Cookies.get("turid")){
            const turid = Cookies.get("turid");
            if(turid === "rid1"){
                setAdmin(true);
            }else{
                Cookies.remove("usr");
                Cookies.remove("turid");
                navigate("/");
                
            }
        }else{
            navigate("/");
            Cookies.remove("usr");
        }
    }
    
    useEffect(() =>{
            validarSesion();
    },[]);
    
    return(
        <div style={{position:'absolute', width:'100%',height:'100%'}}>
            <object
                data={require("../docs/Manual de administrador.pdf")}
                type="application/pdf"
                width="100%"
                height="100%"
            />
        </div>
    );
}

export default AyudaAdmin;